<main-navigation *ngIf="userService.currentUser">
  <main-header></main-header>
</main-navigation>
